module.exports = __webpack_public_path__ + "img/popup-start-sl-img.148dfc1e.png";